<template>
    <div class="select">
        <span class="selected" @click="toggleOptions">{{currentValue.name}}</span>
        <ul class="options" v-if="isOpen">
            <li :class="(currentValue === o) ? 'is-selected': ''" v-for="(o,index) in options" @click="changeValue(o)" :key="index">{{o.name}}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Select",
        props:{
          options:{
              type:Array,
              required:true
          },
            value:{
              type:String,
            }
        },

        data(){
            return{
                currentValue:{
                    name:"",
                    value:""
                },
                isOpen:false,
            }
        },
        methods:{
            toggleOptions(){
                this.isOpen = !this.isOpen
            },
            changeValue(val = null){
                this.currentValue = val
                this.toggleOptions()
                this.$emit('input',this.currentValue.value)
            }
        },
        mounted() {
            let selected = false
            for(let o of this.options){
                if(this.value === o.value){
                    selected = true
                    this.currentValue = o
                    break;
                }
                else if(o.hasOwnProperty('selected') && o.selected){
                    this.currentValue = o
                    selected = true
                }
            }
            if(!selected){
                this.currentValue = this.options[0]
            }
        }
    }
</script>

<style lang="sass">

</style>
